module.exports = __webpack_public_path__ + "pt.2f33a7e78cc207218327.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/pt.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/pt.svg
// module chunks = styles